import { render } from "./RestartLogs.vue?vue&type=template&id=5554dfa1"
import script from "./RestartLogs.vue?vue&type=script&lang=js"
export * from "./RestartLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__